module.exports = __webpack_public_path__ + "static/media/Edit.0d2e6233.png";